import GridSettings from './GridSettings';
export default GridSettings;